import React from 'react';
import MobileTitleSpacer from '../components/MobileTitleSpacer';
import SEO from '../components/SEO';
import { seoConfig } from '../utils/seoConfig';

const Bio = () => {
  return (
    <>
      <SEO 
        title={seoConfig.bio.title}
        description={seoConfig.bio.description}
        keywords={seoConfig.bio.keywords}
        url={seoConfig.bio.url}
      />
      <div className="min-h-screen relative bg-black pt-20 overflow-hidden">
      {/* Fond plein écran */}
      <div className="absolute inset-0 z-0">
        <img
          src="/images/fond pic.jpg"
          alt="Fond coloré"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/30" />
      </div>

      {/* Contenu */}
      <div className="relative z-10">
        {/* Header (on ne touche pas au placement desktop) */}
        <div className="relative overflow-hidden">
          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 md:py-20">
            {/* espace mobile pour passer sous le mini-lecteur */}
            <MobileTitleSpacer height="65px" />

            <h1
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-4 text-white"
              style={{ color: '#7DD3FC' }}
            >
              BIO
            </h1>
            <div
              className="h-1 w-32 md:w-40 mb-6"
              style={{ background: 'linear-gradient(to right, #7DD3FC, transparent)' }}
            />
          </div>
        </div>

        {/* Portrait (remonté uniquement sur desktop) */}
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 md:-mt-6 lg:-mt-10">
          <div className="flex justify-center mb-8 md:mb-10">
            <img
              src="/images/profile.jpg"
              alt="Charles Ludig"
              className="w-28 h-28 sm:w-32 sm:h-32 md:w-40 md:h-40 rounded-full shadow-2xl border-4 border-black/50 object-cover"
            />
          </div>
        </div>

        {/* Texte (cadre plus étroit sur mobile + typo responsive) */}
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 md:-mt-2 lg:-mt-4">
          <div
            className="
              rounded-2xl border-2 mx-auto
              w-full max-w-[92%] sm:max-w-full
              p-5 sm:p-7 md:p-8
            "
            style={{
              background:
                'linear-gradient(135deg, rgba(0, 206, 209, 0.05) 0%, rgba(155, 89, 182, 0.05) 50%, rgba(255, 105, 180, 0.05) 100%)',
              borderColor: 'rgba(255, 255, 255, 0.1)',
            }}
          >
            {/* Titre de section laissé vide comme ton code d’origine */}
            <h2 className="text-2xl sm:text-3xl md:text-3xl font-black text-white mb-4 sm:mb-6"></h2>

            <p className="text-gray-100 text-[15px] sm:text-base md:text-lg leading-7 md:leading-8 mb-4">
              Musicien autodidacte passionné depuis l&apos;enfance par tous les styles musicaux
              (sauf peut-être le zouk love), j&apos;ai grandi au son d&apos;univers éclectiques
              qui nourrissent encore aujourd&apos;hui ma créativité.
            </p>

            <p className="text-gray-100 text-[15px] sm:text-base md:text-lg leading-7 md:leading-8 mb-4">
              Dans mes écouteurs au collège et au lycée, je pouvais enchaîner un album de la
              Fonky Family avec le thème de Rabbi Jacob de Vladimir Cosma, puis basculer sur
              du Tom Petty ; cette diversité d&apos;influences a façonné mon approche de la composition.
            </p>

            <p className="text-gray-100 text-[15px] sm:text-base md:text-lg leading-7 md:leading-8 mb-4">
              J&apos;ai ensuite approfondi mes connaissances techniques audio au sein de la SAE Institute
              à Paris, où j&apos;ai étudié pendant deux ans. C&apos;est à cette période que l&apos;aventure avec le
              Palmashow a véritablement commencé : prise de son, mixage, sound design, composition 
              pour le web et la télévision, avec un aboutissement lors de la composition musicale de
              leurs deux longs-métrages (<em>La Folle Histoire de Max et Léon</em>, <em>Les Vedettes</em>).
            </p>

            <p className="text-gray-100 text-[15px] sm:text-base md:text-lg leading-7 md:leading-8 mb-4">
              Basé à Lyon, dans le quartier des Brotteaux, mon studio est dédié à une recherche musicale
              libre  comme pour la bande originale électro minimaliste du film
              <em> Bonne Conduite</em> de Jonathan Barré ,  mais toujours au service des contraintes
              artistiques propres à chaque projet. J&apos;interviens aussi sur des projets publicitaires,
              institutionnels, courts-métrages ou hybrides , en studio comme sur le terrain.
            </p>

            <p className="text-gray-100 text-[15px] sm:text-base md:text-lg leading-7 md:leading-8 mb-6">
              Aujourd&apos;hui, je poursuis cette exploration avec la sortie de mon EP
              <em> Une Nuit Infinie</em> (en collaboration avec Jonathan Barré),
              où se mélangent toutes ces influences dans un univers électronique personnel.
            </p>

            <a
              href="https://a-vos-marques-tapage.fr/2022/02/24/rencontre-avec-charles-ludig-compositeur-du-palmashow/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full font-bold transition-all duration-300 hover:scale-[1.02]"
              style={{
                background:
                  'linear-gradient(135deg, #13184d00 0%, #1898afb4 50%, #c974a3ff 100%)',
                color: '#fff',
              }}
            >
              <span>Lire mon interview</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                <polyline points="15 3 21 3 21 9"></polyline>
                <line x1="10" y1="14" x2="21" y2="3"></line>
              </svg>
            </a>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default Bio;
